export const MultiConfigsBright = [
    '#52C0FF',
    '#00977B',
    '#C39EFF',
    '#FF92AA',
    '#40D38F',
    '#7622FF',
    '#71C7F8'
];
export const DVColors = {
    InfoBoxes: '#C68600',
    OrphanAlerts: '#CBE3F1',
    ArchivedPeriods: '#43B89A',
    Periods: '#F09737',
    ReconstructedData: MultiConfigsBright[0],
    ImputedData: '#FF6670',
    ActualData: '#A1DAA0'
};
export const getCircularColorScheme = (colorsRequiredNumber, aggregatedColorsNumber = 0, baseColorScheme = MultiConfigsBright) => {
    const nextAggregatedColorsNumber = aggregatedColorsNumber + MultiConfigsBright.length;
    const shouldExtend = colorsRequiredNumber > aggregatedColorsNumber;
    if (!shouldExtend)
        return baseColorScheme;
    const extendedColorScheme = getCircularColorScheme(colorsRequiredNumber, nextAggregatedColorsNumber);
    return [...baseColorScheme, ...extendedColorScheme];
};
